const _excluded = ["onClick", "ariaLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { memo } from 'react';
import styled from 'styled-components';
import { jsx, jsxs } from 'react/jsx-runtime';
const CloseIcon = styled(({
  size = '16',
  className
}) => /*#__PURE__*/jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  width: size,
  height: size,
  className: className,
  children: /*#__PURE__*/jsxs("g", {
    children: [/*#__PURE__*/jsx("polygon", {
      points: "18.096 19.174 19.497 17.747 1.7 .286 .3 1.714"
    }), /*#__PURE__*/jsx("polygon", {
      points: "19.497 1.714 18.096 .286 .3 17.747 1.7 19.174"
    })]
  })
})).withConfig({
  shouldForwardProp: p => !['inverted'].includes(p)
})`
  fill: ${({
  inverted,
  theme
}) => inverted ? theme.colors.background : theme.colors.onBackgroundMuted};

  cursor: pointer;
  transition: fill 0.15s ease;

  &:hover {
    fill: ${({
  theme,
  inverted
}) => inverted ? theme.colors.background : theme.colors.onBackground};
  }
`;
const ButtonWrapper = styled.button`
  background-color: ${({
  theme
}) => theme.colors.background};
`;
const CloseIcon$1 = /*#__PURE__*/memo(_ref => {
  let onClick = _ref.onClick,
    ariaLabel = _ref.ariaLabel,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(ButtonWrapper, {
    onClick: onClick,
    "aria-label": ariaLabel,
    children: /*#__PURE__*/jsx(CloseIcon, _objectSpread({}, props))
  });
});
export { CloseIcon$1 as default };
//# sourceMappingURL=CloseIcon.js.map
